module.exports = __webpack_public_path__ + "static/app-icon-609b974ac8b60ae5a9ab2f1cc8002a7a.png";